module.exports = "/images/ico-classic-grey.png?cb0a41567e7cf35f00f853e70d17988b";


//////////////////
// WEBPACK FOOTER
// ./resources/images/project-img/ico-classic-grey.png
// module id = hlHl
// module chunks = 1